import { render, staticRenderFns } from "./campusRadio.vue?vue&type=template&id=1aa423a8&scoped=true"
import script from "./campusRadio.vue?vue&type=script&lang=js"
export * from "./campusRadio.vue?vue&type=script&lang=js"
import style0 from "./campusRadio.vue?vue&type=style&index=0&id=1aa423a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa423a8",
  null
  
)

export default component.exports